import { CSSProperties } from "react";
import {
  ArrayFieldTemplateItemType,
  FormContextType,
  RJSFSchema,
  StrictRJSFSchema,
} from "@rjsf/utils";

/** The `ArrayFieldItemTemplate` component is the template used to render an items of an array.
 *
 * @param props - The `ArrayFieldTemplateItemType` props for the component
 */
export default function GalleryArrayFieldItemTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any
>(props: ArrayFieldTemplateItemType<T, S, F>) {
  const {
    children,
    className,
    disabled,
    hasToolbar,
    hasMoveDown,
    hasMoveUp,
    hasRemove,
    hasCopy,
    index,
    onCopyIndexClick,
    onDropIndexClick,
    onReorderClick,
    readonly,
    // registry,
    // uiSchema,
  } = props;
  // Usamos botones nativos para evitar props no estándar como `block` en el DOM
  const btnStyle: CSSProperties = {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: "bold",
  };
  return (
    <div className={className}>
      <div className={hasToolbar ? "col-xs-9" : "col-xs-12"}>{children}</div>
      {hasToolbar && (
        <div className="col-xs-3 array-item-toolbox">
          <div
            className="btn-group"
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            {/* TODO - Gallery input - Aquí tenemos los botones de ordenación y eliminar elemento */}
            {(hasMoveUp || hasMoveDown) && (
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                style={btnStyle}
                disabled={disabled || readonly || !hasMoveUp}
                onClick={onReorderClick(index, index - 1)}
                aria-label="Move up"
                title="Move up"
              >
                ▲
              </button>
            )}
            {(hasMoveUp || hasMoveDown) && (
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                style={btnStyle}
                disabled={disabled || readonly || !hasMoveDown}
                onClick={onReorderClick(index, index + 1)}
                aria-label="Move down"
                title="Move down"
              >
                ▼
              </button>
            )}
            {hasCopy && (
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                style={btnStyle}
                disabled={disabled || readonly}
                onClick={onCopyIndexClick(index)}
                aria-label="Copy"
                title="Copy"
              >
                ⧉
              </button>
            )}
            {hasRemove && (
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                style={btnStyle}
                disabled={disabled || readonly}
                onClick={onDropIndexClick(index)}
                aria-label="Remove"
                title="Remove"
              >
                ✕
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
